import React from 'react';
import styled from 'styled-components';
import { JRCIcon } from '../JRCIcon/JRCIcon';

export const VerticalItemFlex = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
`;

export const JRCDefaultIconVerticalItem = styled(JRCIcon)`
    margin-left: 7px;
    margin-right: 9px;
`;

export interface ItemProps {
    isActive: boolean;
}

export const MenuItemWrapper = styled.span`
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-basis: 100%;
    padding: 10px 15px;
    cursor: pointer;
`;

export interface JRCMenuItemProps {
    icon: string;
    label: string;
    size: number;
    attr: string | React.ReactNode;
}
const defaultProps = {
    icon: 'icon-circle-thin',
    size: 20,
};
const JRCMenuItem = (props: JRCMenuItemProps): JSX.Element => {
    return (
        <MenuItemWrapper>
            <VerticalItemFlex>
                <JRCDefaultIconVerticalItem variant="default" name={props.icon} size={props.size} color="" />
                <p>{props.label}</p>
            </VerticalItemFlex>
            <p>{props.attr}</p>
        </MenuItemWrapper>
    );
};
JRCMenuItem.defaultProps = defaultProps;
export { JRCMenuItem };
